import { CSSProperties } from "react";

export const button_hover: CSSProperties = {
    opacity: 0.75,
    transition: '0.15s opacity ease-in-out'
}

export const button_no_hover: CSSProperties = {
    flex: 1,
    flexDirection: 'row',
    justifyContent: 'center',
    flexBasis: '10%',
    alignItems: 'center',
    display: 'flex',
    minHeight: '40px',
    maxWidth: '120px',

    color: 'white',
    // border: '0.5px solid rgba(0,0,0,0.15)',
    borderRadius: '5px',

    cursor: 'pointer',

    opacity: 1.0,
    transition: '0.15s opacity ease-in-out'
}


// WEBPACK FOOTER //
// ./src/custom_components/button_link/button_link.styles.ts